export default __webpack_public_path__ + "static/media/minions.53579ec2.svg";